define('entities/webshop/attribute_matching',[
  'app',
  'settings',
  'underscore'
], function (
  App,
  Settings,
  _
) {
  'use strict';

  // Attribute matching table of the account (backend v2/attribute-matching, formerly a Google Sheet):
  // canonical attributes / values (webshop filters when showInFilters), the supplier customfields
  // and values matched onto them, and the manual values of products.

  var call = function (type, path, params, data) {
    var defer = $.Deferred();

    var options = {
      type: type,
      url: Settings.url('compuzz2', 'v2/attribute-matching/' + path, params || {}),
      success: function (result) {
        defer.resolve(result);
      },
      error: function (jqXHR) {
        var message = '';
        if (jqXHR.responseJSON && jqXHR.responseJSON.error)
          message = jqXHR.responseJSON.error;
        defer.reject(message || _.i18n('attributeMatching.errors.unknown', null, 'Unknown error'));
      }
    };

    if (data) {
      options.data = JSON.stringify(data);
      options.processData = false;
      options.contentType = 'application/json';
    }

    $.ajax(options);
    return defer.promise();
  };

  var API = {
    meta: function () {
      return call('GET', 'meta');
    },

    // Attributes
    keys: function () {
      return call('GET', 'keys');
    },
    addKey: function (data) {
      return call('POST', 'keys', null, data);
    },
    updateKey: function (keyId, data) {
      return call('PUT', 'keys/' + keyId, null, data);
    },
    removeKey: function (keyId) {
      return call('DELETE', 'keys/' + keyId);
    },

    // Values
    values: function (keyId) {
      return call('GET', 'keys/' + keyId + '/values');
    },
    addValue: function (keyId, data) {
      return call('POST', 'keys/' + keyId + '/values', null, data);
    },
    updateValue: function (keyId, valueId, data) {
      return call('PUT', 'keys/' + keyId + '/values/' + valueId, null, data);
    },
    removeValue: function (keyId, valueId) {
      return call('DELETE', 'keys/' + keyId + '/values/' + valueId);
    },
    // Moves every matching of valueId to intoId, then deletes valueId.
    mergeValue: function (keyId, valueId, intoId) {
      return call('POST', 'keys/' + keyId + '/values/' + valueId + '/merge', {into: intoId});
    },

    // Supplier matching
    supplierFields: function (params) {
      return call('GET', 'supplier-fields', params);
    },
    matchFields: function (customFieldIds, keyId) {
      return call('PUT', 'supplier-fields/matching', null, {customFieldIds: customFieldIds, keyId: keyId});
    },
    supplierValues: function (keyId, params) {
      return call('GET', 'keys/' + keyId + '/supplier-values', params);
    },
    // data: {customFieldValueIds, updateAttribute, valueKeyId, updateFilters, filterValueKeyIds}
    matchValues: function (keyId, data) {
      return call('PUT', 'keys/' + keyId + '/supplier-values/matching', null, data);
    },

    // Webshop push
    refresh: function (keyId) {
      return call('POST', 'keys/' + keyId + '/refresh');
    },
    refreshStatus: function () {
      return call('GET', 'refresh');
    },

    // Products (reseller product codes = webshop product codes)
    productValues: function (productCodes) {
      return call('POST', 'products/values', null, {productCodes: productCodes});
    },
    // Everything the category grid screen shows for a webshop category, in one call: columns
    // (attributes) with their values, and a page of products with their canonical values.
    // params: {first, pageSize, lang, search, hideOutdated, hideDisabled, mode, columns, cf, withSubcategories}
    categoryGrid: function (categoryId, params) {
      return call('GET', 'categories/' + categoryId + '/grid', params);
    },
    // PIM option categories / options of a product (reseller code), deactivated ones flagged
    productOptions: function (productCode, lang) {
      return call('GET', 'products/options', {code: productCode, lang: lang});
    },
    // PIM attributes of a product (supplier and manual) with their canonical values
    productAttributes: function (productCode, lang) {
      return call('GET', 'products/attributes', {code: productCode, lang: lang});
    },
    // mode: ADD | REMOVE | REPLACE
    assign: function (productCodes, keyId, valueKeyIds, mode) {
      return call('POST', 'products/assign', null, {
        productCodes: productCodes,
        keyId: keyId,
        valueKeyIds: valueKeyIds,
        mode: mode
      });
    },

    // Name in the dashboard language, then English, then the code.
    name: function (item, lang) {
      var names = (item && item.names) || {};
      lang = lang || Settings.get('lang');
      if (names[lang])
        return names[lang];
      if (names.en)
        return names.en;
      var first = _.find(_.values(names), function (n) { return !!n; });
      return first || (item && item.code) || '';
    },

    // Label of each value, telling apart values sharing a name (duplicates left by the old sheet):
    // "Name", else "Name (code)", else "Name (code) #id". Returns {id: label}.
    labels: function (values) {
      var byName = _.countBy(values, function (v) { return API.name(v).toLowerCase(); });
      var byNameCode = _.countBy(values, function (v) { return API.name(v).toLowerCase() + '|' + (v.code || '').toLowerCase(); });
      var labels = {};
      _.each(values, function (v) {
        var name = API.name(v);
        var label = name;
        if (byName[name.toLowerCase()] > 1) {
          label += ' (' + v.code + ')';
          if (byNameCode[name.toLowerCase() + '|' + (v.code || '').toLowerCase()] > 1)
            label += ' #' + v.id;
        }
        labels[v.id] = label;
      });
      return labels;
    },

    // Ids of the values sharing their name with another value of the attribute.
    duplicateIds: function (values) {
      var byName = _.groupBy(values, function (v) { return API.name(v).toLowerCase(); });
      return _.flatten(_.map(_.filter(byName, function (group) { return group.length > 1; }), function (group) {
        return _.pluck(group, 'id');
      }));
    },

    // extraParam1 is either a '#rrggbb' colour or a free parameter.
    color: function (value) {
      var p = value && value.extraParam1;
      return p && p.charAt(0) === '#' ? p : '';
    }
  };

  return API;
});

